import { useContext } from "react";
import ComboboxSetter from "../Combobox/ComboboxSetter";
import { MotorVehicleDispatchContext, MotorVehicleSearchContext } from "./MotorVehicleSearchReducers";
import { MotorVehicleSearchBy, MvsVinSearchByDefault, MvsVrnSearchByDefault } from "./MotorVehicleSearchTypes";

export function MotorVehicleSearchBySelector() {

	const {
		data: {
			motorVehicleSearchRequest,
			searchByOptions
		}

	} = useContext(MotorVehicleSearchContext);
	const dispatch = useContext(MotorVehicleDispatchContext);

	const setSearchBy = (value: MotorVehicleSearchBy) => {
		dispatch({
			type: "SetMotorVehicleSearchRequest",
			payload: {
				motorVehicleSearchRequest: value === "Vin"
					? MvsVinSearchByDefault
					: MvsVrnSearchByDefault,
			}
		});
	}

	return (
		<ComboboxSetter
			value={motorVehicleSearchRequest?.searchBy}
			setValue={setSearchBy}
			options={searchByOptions}
			getOptionValue={item => item}
			label="Search By"
			placeholder="Search by"
			isRequired
		/>
	)
};